import { render, staticRenderFns } from "./Search-legal-entity.vue?vue&type=template&id=469f5ae6"
import script from "./Search-legal-entity.vue?vue&type=script&lang=js"
export * from "./Search-legal-entity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports